import { render, staticRenderFns } from "./shopDetails.vue?vue&type=template&id=ecdfed74&scoped=true"
import script from "./shopDetails.vue?vue&type=script&lang=js"
export * from "./shopDetails.vue?vue&type=script&lang=js"
import style0 from "./shopDetails.vue?vue&type=style&index=0&id=ecdfed74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdfed74",
  null
  
)

export default component.exports